import Arabic from './arabic/Router'
import Africa from './africa/Router'
import Apac from './apac/Router'
import Chinese from './chinese/Router'
import Global from './global/Router'
import Latam from './latam/Router'

/*
 * Syntax: path: Component
 * Example: chinese: Chinese
 */
export default {
  arabic: Arabic,
  africa: Africa,
  apac: Apac,
  chinese: Chinese,
  global: Global,
  latam: Latam,
}
